import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AirtalkService {

  readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Ocp-Apim-Subscription-Key': environment.airtalkSubscriptionKey,
      'as-frameworkversion': '1.0',
      'as-callername': 'TMWEB',
      'as-userid': 'AirTalk'
    })
  };

  constructor(private oauthService: OAuthService, private http: HttpClient) { }

  getTwilioToken(): Observable<AirtalkTokenResponse> {
    const body = { 'oauthToken': this.oauthService.getAccessToken(), 'isAirTalkConversation': true };
    const airtalkTokenCreateUrl = environment.airtalkUrl + '/token/create';
    console.log('getTwilioToken() called');
    
    return this.http.post<AirtalkTokenResponse>(airtalkTokenCreateUrl, body, this.httpOptions).pipe(
      catchError(this.handleError<AirtalkTokenResponse>('getTwilioToken', undefined))
    );
  }

  getConfiguration(): Observable<AirTalkConfiguration> {
    console.log('airtalkService.getConfiguration');

    console.log(this.httpOptions);
    
    const airtalkConfigurationUrl = environment.airtalkUrl + '/configuration';
    console.log(airtalkConfigurationUrl);
    
    return this.http.get<AirTalkConfiguration>(airtalkConfigurationUrl, this.httpOptions).pipe(
      catchError(this.handleError<AirTalkConfiguration>('getConfiguration', {roles: []}))
    );
  }

  /**
   * Joins a participant to an active conversation. Creates the conversation if it doesn't exist.
   */
  joinConversation(conversationName: string, participantIdentity: string, userInfo: ConversationUserInfo): Observable<JoinConversationResponse> {
  console.log('joinConversation() called');
  console.log('Conversation name:', conversationName);
  console.log('Participant identity:', participantIdentity);
  console.log('User info:', userInfo);

  const body: ConversationJoinRequest = {
    participantIdentity: participantIdentity,
    userInfo: userInfo
  };

  // Construct the API endpoint - assuming version 1 for now
  const joinUrl = `${environment.airtalkUrl}/conversations/join?conversationName=${encodeURIComponent(conversationName)}`;
  console.log('Join endpoint:', joinUrl);
  console.log('Request body:', body);

  return this.http.post<JoinConversationResponse>(joinUrl, body, this.httpOptions).pipe(
    catchError(this.handleError<JoinConversationResponse>('joinConversation', {
      success: false,
      message: 'Failed to join conversation',
      conversationName: conversationName
    }))
  );
}

    /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      console.error(error); 

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
export interface AirtalkTokenResponse {
  twilioToken: string;
  firstName: string;
  lastName: string;

}

export interface Theme {
  textColor: string;
  backgroundColor: string;
}

export interface Themes {
  default: Theme;
}

export interface Position {
  position: string;
  displayName: string;
}

export interface Role {
  role: string;
  displayName: string;
  abbreviation: string;
  themes: Themes;
  positions: Position[];
}

export interface AirTalkConfiguration {
  roles: Role[];
}

// New interfaces for conversation joining
export interface ConversationUserInfo {
  role: string;
  position: string;
}

export interface ConversationJoinRequest {
  participantIdentity: string;
  userInfo: ConversationUserInfo;
}

export interface JoinConversationResponse {
  /// Indicates whether the operation was successful
  success: boolean;
  /// Error message if the operation failed
  message?: string;
  /// The SID of the conversation
  conversationSid?: string;
  /// The unique name of the conversation
  conversationName?: string;
  /// The SID of the participant
  participantSid?: string;
  /// Indicates whether a new conversation was created
  conversationCreated?: boolean;
  /// Indicates whether the participant was added to the conversation
  participantAdded?: boolean;
}
